// extracted by mini-css-extract-plugin
export default {"shortz_container":"ShortzVideoPlayer_shortz_container__nf96i","shortz":"ShortzVideoPlayer_shortz__FRGfC","shortz_loading":"ShortzVideoPlayer_shortz_loading__wrJ3-"};